import UserProfile from "../components/user/UserProfile";

const UserPage = () => {
  return <UserProfile />;
};

export default UserPage;
